import styled from "styled-components";
import {brand, radii} from "theme/tokens";

/**
 * Externalized styles for {@link ./PickedImageOutcome} — one copy of what used to be two.
 *
 * These lived twice, in `sponsor/SponsorPage.styles.ts` and `account/brand/PageThemeSection.styles.ts`,
 * byte-identical apart from a word in a comment (ui#752). Every value is token-driven, so the block
 * reads in both modes wherever it is mounted.
 */

/**
 * The block itself.
 *
 * Its own block rather than a toast: one pick can report several independent problems at once, and six
 * toasts for six files is a stack the user must dismiss before they can see the row those files were
 * meant to join.
 *
 * `brand.error` for the edge — mode-independent, like every other destructive affordance — with the
 * per-mode `errorInk` for the copy, which is the pair that stays legible on a card surface.
 */
export const Root = styled.div`
	margin: 12px 0 0;
	padding: 10px 12px;
	border-radius: ${radii.control};
	background: ${({theme}) => theme.tokens.field};
	border: 1px solid ${brand.error};
	color: ${({theme}) => theme.tokens.errorInk};
	font-size: 13px;
	line-height: 1.5;
`;

export const Title = styled.p`
	margin: 0;
	font-weight: 700;
`;

export const List = styled.ul`
	margin: 4px 0 0;
	padding-inline-start: 18px;
	/* Long filenames are the user's, not ours, and must not push the surface sideways. */
	overflow-wrap: anywhere;
`;
